// recoil/configs/atoms.ts
import { atom } from 'recoil';

// Define the interface for your configuration object
interface Config {
  interactive_ui: string;
}

export const configState = atom<Config | null>({
  key: 'configState',
  default: null,
});
